import FpuiDashboardingLayout from './FpuiDashboardingLayout'
import FpuiDashboardingLayoutLite from './FpuiDashboardingLayoutLite'

export { FpuiDashboardingLayout, FpuiDashboardingLayoutLite }
export default { FpuiDashboardingLayout, FpuiDashboardingLayoutLite }
